import React from 'react';
import { TableCell, Typography } from '@mui/material';
import { classes } from './styles';
import { TSortableColumn } from '../Components/GenericTable/types';
import { ICandidateSourcingSearch } from './types';
import FormattedDate from '../Components/GenericTable/TableCells/FormattedDate';

export const searchTableColumn: TSortableColumn[] = [
  { id: 'id', label: 'ID', sortable: true, canToggle: true, enabled: true },
  { id: 'name', label: 'Name', sortable: true, canToggle: true, enabled: true },
  { id: 'executed_at', label: 'Last Search', sortable: true, canToggle: true, enabled: true },
  {
    id: 'candidate_groups_count',
    label: 'Found Candidates',
    sortable: false,
    canToggle: true,
    enabled: true
  },
  {
    id: 'screened_candidates_count',
    label: 'Screened Candidates',
    sortable: false,
    canToggle: true,
    enabled: true
  },
  { id: 'stage', label: 'Stage', sortable: false, canToggle: true, enabled: true }
];

interface SearchTableRowsProps {
  column: TSortableColumn;
  item: ICandidateSourcingSearch;
  tableHovered: boolean;
  dispatch?: any;
}

const SearchTableRows: React.FC<SearchTableRowsProps> = ({
  column,
  item,
  tableHovered,
  dispatch
}) => {
  const formatDate = (dateString: string) => {
    if (!dateString) return 'Never';
    return <FormattedDate date={dateString} />;
  };

  const handleViewSearch = () => {
    if (item.screened_candidates_count > 0) {
      handleViewScreening();
    } else {
      handleViewMatching();
    }
  };

  const handleViewMatching = () => {
    window.location.href = `/admin/candidate_sourcing/searches/${item.id}`;
  };

  const handleViewScreening = () => {
    if (item.screened_candidates_count > 0) {
      window.location.href = `/admin/candidate_sourcing/searches/${item.id}/screening`;
    }
  };

  switch (column.id) {
    case 'id':
      return (
        <TableCell>
          <Typography variant="body2" sx={{ cursor: 'pointer' }} onClick={handleViewSearch}>
            {item.id}
          </Typography>
        </TableCell>
      );
    case 'name':
      return (
        <TableCell>
          <Typography variant="body2" sx={{ cursor: 'pointer' }} onClick={handleViewSearch}>
            {item.name || `Search #${item.id}`}
          </Typography>
        </TableCell>
      );
    case 'candidate_groups_count':
      return (
        <TableCell>
          <Typography variant="body2" sx={{ cursor: 'pointer' }} onClick={handleViewMatching}>
            {item.candidate_groups_count || '-'}
          </Typography>
        </TableCell>
      );
    case 'screened_candidates_count':
      return (
        <TableCell>
          <Typography variant="body2" sx={{ cursor: 'pointer' }} onClick={handleViewScreening}>
            {item.screened_candidates_count || '-'}
          </Typography>
        </TableCell>
      );
    case 'stage':
      return (
        <TableCell>
          <Typography
            variant="body2"
            sx={item.screened_candidates_count > 0 ? classes.screeningBadge : classes.matchingBadge}
          >
            {item.screened_candidates_count > 0 ? 'Screening' : 'Matching'}
          </Typography>
        </TableCell> 
      );
    case 'executed_at':
      return (
        <TableCell>
          <Typography variant="body2">{formatDate(item.executed_at)}</Typography>
        </TableCell>
      );

    default:
      return <TableCell />;
  }
};

export default SearchTableRows;
